import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e57642"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column-fluid row p-md-20 py-20 m-0",
  id: "conten-login"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col col-xl-6 col-12\" data-v-15e57642><div class=\"d-flex align-items-start flex-column\" data-v-15e57642><a href=\"#\" class=\"logo\" data-v-15e57642><img alt=\"Logo\" src=\"media/logos/logo-melon-sin-fondo.png\" data-v-15e57642></a><div class=\"flex-column d-flex flex-center me-auto px-5\" style=\"\" data-v-15e57642><h1 class=\"text-white fs-3x\" style=\"font-weight:700;\" data-v-15e57642> ¡Bienvenido! </h1><div class=\"fs-3 text-white mb-10\" data-v-15e57642> Puedes solicitar una cuenta para acceder al portal. <br data-v-15e57642> Una vez enviado, un ejecutivo validará la información<br data-v-15e57642> y te enviaremos la información para acceder. </div></div></div></div>", 1)
const _hoisted_3 = { class: "col col-xl-6 col-12" }
const _hoisted_4 = { class: "w-lg-500px rounded shadow-sm p-7 ms-auto" }
const _hoisted_5 = { class: "mb-10 text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-blue mb-3",
  style: {"font-size":"1.25rem !important"}
}, " Solicita una cuenta de acceso al portal ", -1))
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-5" }
const _hoisted_8 = { class: "fv-row mb-7" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Rut del Proveedor", -1))
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row fv-row mb-7" }
const _hoisted_13 = { class: "col-xl-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Nombres", -1))
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "col-xl-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Apellidos", -1))
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "fv-row mb-7" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Email", -1))
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-7" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Teléfono", -1))
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "fv-row mb-10" }
const _hoisted_30 = { class: "form-check form-check-custom" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6 texto-checkbox" }, [
  /*#__PURE__*/_createTextVNode(" Estoy de acuerdo con los "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/media/misc/CondicionesGeneralesOC.pdf",
    target: "_blank",
    class: "ms-1 link-primary"
  }, "Términos y condiciones"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = {
  key: 0,
  class: "mensajeError"
}
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-md btn-melon w-100 mb-5"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Enviar ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Por favor espere... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1))
const _hoisted_41 = { class: "text-center m-10" }
const _hoisted_42 = {
  key: 0,
  class: "flex-row-fluid d-flex flex-center justfiy-content-xl-first"
}
const _hoisted_43 = { class: "w-lg-400px rounded shadow-sm p-lg-7 ms-auto" }
const _hoisted_44 = { class: "mb-10 text-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, " Solicita una cuenta de acceso al portal ", -1))
const _hoisted_46 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_47 = { class: "fv-row mb-7" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Rut del Proveedor", -1))
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "row fv-row mb-7" }
const _hoisted_52 = { class: "col-xl-6" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Nombres", -1))
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "col-xl-6" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Apellidos", -1))
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "fv-row mb-7" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Email", -1))
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "fv-row mb-7" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-blue" }, "Teléfono", -1))
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "fv-row mb-10" }
const _hoisted_69 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Estoy de acuerdo con los "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/media/misc/CondicionesGeneralesOC.pdf",
    target: "_blank",
    class: "ms-1 link-primary"
  }, "Términos y condiciones"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-md btn-primary w-100 mb-5"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Enviar ", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Por favor espere... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1))
const _hoisted_77 = { class: "text-center m-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          class: "form w-100 col-12",
          novalidate: "novalidate",
          onSubmit: _ctx.onSubmitRegister,
          id: "kt_login_signup_form",
          "validation-schema": _ctx.registration
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" ¿Ya tienes una cuenta? "),
                _createVNode(_component_router_link, {
                  to: "/sign-in",
                  class: "link-primary fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Login ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: "",
                name: "rutProveedor",
                onKeyup: _ctx.formatRut,
                modelValue: _ctx.form.rut,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.rut) = $event)),
                autocomplete: "off"
              }, null, 8, ["onKeyup", "modelValue"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ErrorMessage, { name: "rutProveedor" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg",
                  type: "text",
                  placeholder: "",
                  name: "contactoNombre",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ErrorMessage, { name: "contactoNombre" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg",
                  type: "text",
                  placeholder: "",
                  name: "contactoApellido",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_ErrorMessage, { name: "contactoApellido" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "email",
                placeholder: "",
                name: "contactoEmail",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_ErrorMessage, { name: "contactoEmail" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "phone",
                placeholder: "",
                name: "contactoTelefono",
                autocomplete: "off",
                onKeydown: _ctx.validarNumero
              }, null, 8, ["onKeydown"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_ErrorMessage, { name: "contactoTelefono" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  type: "checkbox",
                  name: "terminoycondiciones",
                  value: false,
                  onChange: _ctx.marcarTerminoYCondiciones
                }, null, 8, ["onChange"]),
                _hoisted_31
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.mensajeTerminoCondiciones)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, " El campo es obligatorio "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", _hoisted_36, _hoisted_39, 512)
            ]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_router_link, {
                to: "/sign-in",
                class: "btn btn-melon-secundario mb-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Volver ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              novalidate: "novalidate",
              onSubmit: _ctx.onSubmitRegister,
              id: "kt_login_signup_form",
              "validation-schema": _ctx.registration
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createTextVNode(" ¿Ya tienes una cuenta? "),
                    _createVNode(_component_router_link, {
                      to: "/sign-in",
                      class: "link-primary fw-bolder"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Login ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "text",
                    placeholder: "",
                    name: "rutProveedor",
                    onKeyup: _ctx.formatRut,
                    modelValue: _ctx.form.rut,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.rut) = $event)),
                    autocomplete: "off"
                  }, null, 8, ["onKeyup", "modelValue"]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_ErrorMessage, { name: "rutProveedor" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "",
                      name: "contactoNombre",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_ErrorMessage, { name: "contactoNombre" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "",
                      name: "contactoApellido",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_ErrorMessage, { name: "contactoApellido" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "email",
                    placeholder: "",
                    name: "contactoEmail",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_ErrorMessage, { name: "contactoEmail" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg",
                    type: "phone",
                    placeholder: "",
                    name: "contactoTelefono",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_ErrorMessage, { name: "contactoTelefono" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("label", _hoisted_69, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "toc",
                      value: "1"
                    }),
                    _hoisted_70
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("button", _hoisted_72, _hoisted_75, 512)
                ]),
                _hoisted_76,
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_router_link, {
                    to: "/sign-in",
                    class: "btn btn-secondary btn-outline-secondary mb-5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Volver ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}